import { html } from "src/components/HtmlViewer/utils";
import * as GQL from "src/types/graphql";

export const FORM_SUBMITTED_RANK_ENABLED = {
  type: GQL.message_template_type_enum.FormSubmitted,
  emailSubject:
    "You have successfully submitted your {{organization.name}} application! / ¡Ha enviado exitosamente su aplicación {{organization.name}}!",
  emailText: `Dear {{parent.name}},

Thank you for submitting your {{organization.name}} application for {{student.name}} for grade {{grade}} for the {{enrollmentPeriod.name}}.

The school choices you submitted are
{{schools.name}}

You can edit your form from your Avela homepage: {{applyUrl}}.

We will attempt to match your child to your highest possible choice with space available. You will be notified by email when offers will go out.

If you need help, please contact {{organization.name}}.

_____________________________________________

Estimado/a {{parent.name}},

Gracias por enviar su aplicación de {{organization.name}} para {{student.name}} para el grado {{grade}} para el {{enrollmentPeriod.name}}.

Sus elecciones de escuelas enviadas son
{{schools.name}}

Puede editar su aplicación: {{applyUrl}}

Intentaremos hacer coincidir a su hijo/a con su elección posible más alta que tenga espacio disponible. Se le notificará por correo electrónico con la escuela escogida.

Si necesita ayuda, por favor contacte a {{organization.name}}.`,
  emailHtml: html`
    <p>
      Dear {{parent.name}},<br />
      <br />
      Thank you for submitting your {{organization.name}} application for
      {{student.name}} for grade {{grade}} for the {{enrollmentPeriod.name}}.<br />
      <br />
      The school choices you submitted are<br />
      {{schools.name}}
      <br />
      You can edit your form from your Avela homepage: {{applyUrl}}.<br />
      <br />
      We will attempt to match your child to your highest possible choice with
      space available. You will be notified by email when offers will go out.<br />
      <br />
      If you need help, please contact {{organization.name}}.<br />
    </p>
    <p>_____________________________________________</p>
    <p>
      Estimado/a {{parent.name}},<br />
      <br />
      Gracias por enviar su aplicación de {{organization.name}} para
      {{student.name}} para el grado {{grade}} para el
      {{enrollmentPeriod.name}}.<br />
      <br />
      Sus elecciones de escuelas enviadas son<br />
      {{schools.name}}
      <br />
      Puede editar su aplicación: {{applyUrl}}<br />
      <br />
      Intentaremos hacer coincidir a su hijo/a con su elección posible más alta
      que tenga espacio disponible. Se le notificará por correo electrónico con
      la escuela escogida.<br />
      <br />
      Si necesita ayuda, por favor contacte a {{organization.name}}.<br />
    </p>
  `,
  sms: `You've submitted your {{organization.name}} application! You can edit here: {{applyUrl}} / Ha enviado su aplicación de {{organization.name}}. Puede editar aquí: {{applyUrl}} / School choices / Las opciones: {{schools.name}}`,
};
